import {
  ADDADVERTISEMENT,
  ADDALLOFFERSBYADMIN,
  ADDMANUALRECHARGE,
  ADDWHATSAPPMESSAGECOUNT,
  GETALLMOBILEADVERTISEMENT,
  GETALLOFFERSBYADMIN,
  GETALLUSERDETAILS,
  GETALLWEBADVERTISEMENT,
  UPDATEADVERTISEMENT,
  UPDATEALLOFFERSBYADMIN,
  UPDATELUSERDETAILS,
} from "../../utils/api";
import axios from "../../utils/axios";
import { Toast } from "../../utils/commonUtils";

export const addRechargeManual = async (payload, callback) => {
  await axios
    .post(ADDMANUALRECHARGE, payload)
    .then((res) => {
      console.log("res search ", res);

      if (res?.data?.success) {
        console.log("res search ", res?.data);
        Toast.fire({
          icon: "success",
          title: res?.data?.message,
        });
        callback(res?.data);
      } else {
        Toast.fire({
          icon: "error",
          title: res?.data?.message,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const addWhatsappMessageCount = async (payload, callback) => {
  await axios
    .post(ADDWHATSAPPMESSAGECOUNT, payload)
    .then((res) => {
      // console.log("res search ", res);

      if (res?.data?.data?.success) {
        console.log("res whatsappCountMessage ", res?.data);
        Toast.fire({
          icon: "success",
          title: res?.data?.message,
        });
        callback(res?.data);
      } else {
        Toast.fire({
          icon: "error",
          title: res?.data?.message,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

// import { GETALLOFFERS } from "../../utils/api";
// import axios from "../../utils/axios";

export const GetAllAdvertisement = async (params) => {
  const res = await axios.get(GETALLWEBADVERTISEMENT, params);
  return res;
};
export const GetAllMobileAdvertisement = async (params) => {
  const res = await axios.get(GETALLMOBILEADVERTISEMENT, params);
  return res;
};

export const AddAdvertisementApi = async (params) => {
  const res = await axios.post(ADDADVERTISEMENT, params);
  return res;
};

export const UpdateAdvertisementApi = async (params) => {
  const res = await axios.post(UPDATEADVERTISEMENT, params);
  return res;
};

export const GetAllOffersByAdmin = async (params) => {
  const res = await axios.get(GETALLOFFERSBYADMIN, params);
  return res;
};
export const ADDAllOffersByAdmin = async (params) => {
  const res = await axios.post(ADDALLOFFERSBYADMIN, params);
  return res;
};
export const UpdateAllOffersByAdmin = async (params) => {
  const res = await axios.post(UPDATEALLOFFERSBYADMIN, params);
  return res;
};

export const GetAllUserProfile = async (params) => {
  const res = await axios.post(GETALLUSERDETAILS, params);
  return res;
};
export const updateUser = async (payload, callback) => {
  await axios.post(UPDATELUSERDETAILS, payload).then((res) => {
    // callback(res?.data);
  });
};
